import React from 'react';
import { getConfiguration } from '../data/utils';

function PartialScores(props) {
    const scores = [];
    const conf = getConfiguration();
    props.match.score.currentScore.forEach((sc, i) => {
        if ((i >= 1 && i <= 4) || (props.match.sportRef !== 4 && i === 5) || (props.match.sportRef !== 23 && i === 6)) {
            if (sc != null) {
                const score2 = sc[`score${i + 1}`];
                if (score2 !== '') {
                    const parts = score2.split('#');
                    scores.push(
                        <div key={i} className="tabellaQuoteRisultatiParziali-risultatoParziale">
                            <p className="font-weight-bold partialScores__wrapper"><span className='partialScores__periodo'>{conf.iwh ? props.match.score.periodo : parts[0]}</span><span className='partialScores__scores'>{` (${parts[1].replace(/\s+/g, '')})`}</span></p>
                        </div>
                    );
                }
            }
        }
    });
    return scores;
}

export default PartialScores;